<template>
    <div>
		<hr>
		<div v-if="!isEmptyObject(meta)">
			<div class="form-group">
				<label for="title" class="font-weight-bold">Widget Label</label>
				<input type="text" class="form-control" v-model="meta.title" id="title" placeholder="Label yang akan ditampilkan di homepage">
			</div>
			<hr>
		</div>
		<div class="form-group">
			<label for="url">Title</label>
			<input type="text" class="form-control" v-model="config.title" id="url" placeholder="Input title for banner" required>
		</div>
		<div class="row">
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="url">First Link To</label>
					<input type="text" class="form-control" v-model="config.first_url" id="url" placeholder="Input url for first banner" required>
				</div>
			</div>
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="url">Second Link To</label>
					<input type="text" class="form-control" v-model="config.second_url" id="url" placeholder="Input url for second banner" required>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-lg-6">
				<!-- start upload first image area -->
				<div class="form-group">
					<label for="image">First Image</label>
					<button class="btn btn-sm btn-plain text-danger" v-if="config.first_image_url !== undefined && config.first_image_url !== ''" @click="removeImage('first_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image" v-if="config.first_image_url !== undefined && config.first_image_url !== ''">
						<img class="img-fluid rounded" :src="config.first_image_url" alt="Uploaded Image">
					</div>
					<div
						v-if="isFirstImageUploading && config.first_image_url === ''"
						class="pc-image-empty"
					>
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div
						v-else-if="config.first_image_url === ''"
						class="pc-image-empty cursor-pointer"
						@click="uploadImage('first_image')"
					>
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 1300x183px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
			<!-- start upload second image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">Second Image</label>
					<button class="btn btn-sm btn-plain text-danger" v-if="config.second_image_url !== undefined && config.second_image_url !== ''" @click="removeImage('second_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image" v-if="config.second_image_url !== undefined && config.second_image_url !== ''">
						<img class="img-fluid rounded" :src="config.second_image_url" alt="Uploaded Image">
					</div>
					<div
						v-if="isSecondImageUploading && config.second_image_url === ''"
						class="pc-image-empty"
					>
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div
						v-else-if="config.second_image_url === ''"
						class="pc-image-empty cursor-pointer"
						@click="uploadImage('second_image')"
					>
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 1300x183px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
		</div>
		<!-- start upload mobile image -->
		<div class="row">
			<div class="col-12 col-lg-6">
				<!-- start upload first image area -->
				<div class="form-group">
					<label for="image">First Mobile Image</label>
					<button class="btn btn-sm btn-plain text-danger" v-if="config.first_mobile_image_url !== undefined && config.first_mobile_image_url !== ''" @click="removeImage('first_mobile_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image" v-if="config.first_mobile_image_url !== undefined && config.first_mobile_image_url !== ''">
						<img class="img-fluid rounded" :src="config.first_mobile_image_url" alt="Uploaded Image">
					</div>
					<div
						v-if="isFirstMobileImageUploading && config.first_mobile_image_url === ''"
						class="pc-image-empty"
					>
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div
						v-else-if="config.first_mobile_image_url === ''"
						class="pc-image-empty cursor-pointer"
						@click="uploadImage('first_mobile_image')"
					>
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 640x640px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
			<!-- start upload second image area -->
			<div class="col-12 col-lg-6">
				<div class="form-group">
					<label for="image">Second Mobile Image</label>
					<button class="btn btn-sm btn-plain text-danger" v-if="config.second_mobile_image_url !== undefined && config.second_mobile_image_url !== ''" @click="removeImage('second_mobile_image')">
						<i class="bi-x-circle"></i> Remove Image
					</button>
					<div class="my-2 text-center preview-image" v-if="config.second_mobile_image_url !== undefined && config.second_mobile_image_url !== ''">
						<img class="img-fluid rounded" :src="config.second_mobile_image_url" alt="Uploaded Image">
					</div>
					<div
						v-if="isSecondMobileImageUploading && config.second_mobile_image_url === ''"
						class="pc-image-empty"
					>
						<div class="image-loading">
							<div class="is-loading"></div>
						</div>
					</div>
					<div
						v-else-if="config.second_mobile_image_url === ''"
						class="pc-image-empty cursor-pointer"
						@click="uploadImage('second_mobile_image')"
					>
						<div class="image-upload-placeholder">
							<i class="fi fi-rr-picture image-placeholder"></i>
							<div class="text-placeholder">
								Klik untuk upload.
							</div>
						</div>
					</div>
					<div class="pc-input-desc">
						Upload image dengan resolusi 1300x183px agar fit dengan ukuran banner.
					</div>
				</div>
			</div>
		</div>
		<div class="form-group buttons m-0 hidden">
			<input
				type="file"
				accept="image/*"
				class="input-file"
				ref="imageUploader"
				id="pc-product-images-file"
				@change="onInputImageChange"
				multiple
			/>
			<label
				for="pc-product-images-file"
				class="btn btn-primary"
				:class="{ 'is-loading': isFirstImageUploading || isSecondImageUploading || isFirstMobileImageUploading || isSecondMobileImageUploading }"
				>Upload images</label
			>
			<div class="pc-input-desc">
				Make sure your image resolution is 1296x324 px
			</div>
		</div>
		<!-- end upload image area -->
	</div>
</template>
<script>
import mediaApi from '@/api/media';
import { isEmptyObject } from '@/lib/helper';

export default {
	name: 'TwoColumnBanner',
	props: {
		config: {
			type: Object,
			default: () => ({
				title: 'Two Column Banner',
				first_url: '',
				first_image_url: 'https://cdn.ostock.id/img/banner/inventro-banner-1.png',
				first_mobile_image_url: '',
				second_url: '',
				second_image_url: 'https://cdn.ostock.id/img/banner/inventro-banner-1.png',
				second_mobile_image_url: '',
			}),
		},
		meta: {},
	},
	data() {
		return {
			isFirstImageUploading: false,
			isFirstMobileImageUploading: false,
			isSecondImageUploading: false,
			isSecondMobileImageUploading: false,
			stateUpload: 'first_image',
		};
	},
	methods: {
		isEmptyObject,
		removeImage(state) {
			if (state === 'first_image') {
				this.$set(this.config, 'first_image_url', '');
			} else if (state === 'second_image') {
				this.$set(this.config, 'second_image_url', '');
			} else if (state === 'first_mobile_image') {
				this.$set(this.config, 'first_mobile_image_url', '');
			} else {
				this.$set(this.config, 'second_mobile_image_url', '');
			}
		},
		uploadImage(state) {
			console.log('up');
			this.stateUpload = state;
			const inputFile = this.$refs.imageUploader;
			console.log(inputFile);
			inputFile.click();
		},
		onInputImageChange(event) {
			if (this.stateUpload === 'first_image') {
				this.isFirstImageUploading = true;
				this.$set(this.config, 'first_image_url', '');
			} else if (this.stateUpload === 'second_image') {
				this.isFirstMobileImageUploading = true;
				this.$set(this.config, 'second_image_url', '');
			} else if (this.stateUpload === 'first_mobile_image') {
				this.isSecondImageUploading = true;
				this.$set(this.config, 'first_mobile_image_url', '');
			} else {
				this.isSecondMobileImageUploading = true;
				this.$set(this.config, 'second_mobile_image_url', '');
			}
			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'admin-sliders',
						text: noticeMessage,
						type: 'warn',
					});
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					this.isUploading = false;
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;

					if (this.stateUpload === 'first_image') {
						this.isFirstImageUploading = false;
						this.$set(this.config, 'first_image_url', url);
					} else if (this.stateUpload === 'second_image') {
						this.isFirstMobileImageUploading = false;
						this.$set(this.config, 'second_image_url', url);
					} else if (this.stateUpload === 'first_mobile_image') {
						this.isSecondImageUploading = false;
						this.$set(this.config, 'first_mobile_image_url', url);
					} else {
						this.isSecondMobileImageUploading = false;
						this.$set(this.config, 'second_mobile_image_url', url);
					}
				};

				const errorCallback = (e) => {
					this.isFirstImageUploading = false;
					this.isFirstMobileImageUploading = false;
					this.isSecondImageUploading = false;
					this.isSecondMobileImageUploading = false;
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
	},
};
</script>
<style lang="scss" scoped>
	label {
		font-weight: 700;
		font-size: 16px;
		line-height: 150%;
	}

	.form-control {
		border: 2px solid #1F1F1F61;
		height: calc(2.3em + 0.75rem + 2px);
	}

	.single-banner {
		img {
			border-radius: 16px;
		}
	}
</style>
